import SectionHeader from "../sectionHeader/"

import "./About.css"



const About = () => {

    return (
        <div className="about-section" id="About">
            <SectionHeader title="About"/>
            <div className="about">
          <div className="explain">
             <p>
               Hi!, my name is Sfundo, I am a JavaScript developer, I develop for all plartforms(mobile, desktop and the web) using JavaScript,
               I've been coding for over four years now, I started back in 2018 while doing my first year as a Criminology and Philosophy major.
          
             </p>
             <p>
               over the years I have successfully finished multiple freelance, personal and npm projects, Although I lean more 
               towards the Front-end, I am comfortable with the back-end, including servers and databases, Here are few
               technologies I am comfortable with:  
             </p>
             
        <div className="technologies">
          <div>
           <h3>Front-end</h3>
            <li>Ionic</li>
            <li>React</li>
            <li>Angular</li>
            <li>Vue</li>
            <li>NativeScript</li>
            <li>Electron</li>

          </div>

          <div>
            <h3>languages</h3>
            <li>JavaScript</li>
            <li>Typescript</li>
            <li>Python</li>
            <li>C#</li>
          </div>

          <div>
          <h3>Back-end</h3>
            <li>Nodejs</li>
            <li>Express</li>
            <li>Supabase</li>
           
          </div>

        </div>
          </div>
          <div className="image">
           <img src="/assets/images/sfundoDevimg.jpg"/>
          </div>

           </div>
        </div>
    )
}

export default About